import React from 'react'
import { format } from 'date-fns'

class ListItem extends React.Component {  
  getEventDate() {
		const event = this.props.event.schedule
		const date = `${event.orgEventDate} ${event.orgEventTime}`

		let dateStr = ''
		dateStr += format(date, 'dddd')
		dateStr += ' | '
		dateStr += format(date, 'MMM D, YYYY')
		if (event.showTime)
			dateStr += ` | ${format(date, 'hh:mm A')}`
    if (event.orgDoorTime)  
      dateStr += ` | Doors open at ${format(`${event.orgEventDate} ${event.orgDoorTime}`, 'hh:mm A')}` 
    
      return dateStr
  }
  
  render() {
    const event = this.props.event

    return (
      <div 
        className="event-list-item" 
        tabIndex="0"
        key={event.id} 
        data-url={event.gist.permalink} 
        onKeyPress={ e => e.key === 'Enter' && this.props.gotoEvent(e) }
        onClick={e => this.props.gotoEvent(e)}
        role="link"
        aria-label={ event.gist.title + ' ' + this.getEventDate() }
      >
        <div className="event-image-container">
          <div className="event-image" style={{ backgroundImage: `url(${event.gist.landscapeImageUrl})` }}></div>
        </div>
        <div className="event-date-container">
          <div className="title">{event.gist.title}</div>
          <div className="event-date">
            { this.getEventDate() }
          </div>
        </div>
        <div className="event-tickets-container">
          { event.gist.ticketUrl && 
            <a 
            href={event.gist.ticketUrl} 
            aria-label={`Tickets for ${event.gist.title}`}
            target='_blank' 
            className="event-tickets" 
            onClick={ e => e.stopPropagation() }
            >
              Tickets
            </a>
          }
        </div>
      </div>
    )
  }
}

export default ListItem;